import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import AdminPage from "./AdminPage";
import RequestPage from "./RequestPage";
import RequestsAdminPage from "./RequestsAdminPage";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/peticiones" element={<RequestPage />} />
        <Route path="/peticiones-admin" element={<RequestsAdminPage />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
        
      </Routes>
    </Router>
  );
}
